<template>
    <div class="notification-handler">
        <div>
            <TransitionGroup
                tag="div"
                name="notification-transition"
                class="notification-handler-container"
            >
                <NotificationBanner
                    v-for="notification in notifications"
                    :ref="`notif${notification.notifId}`"
                    :key="notification.notifId"
                    v-bind="notification"
                    @clear="onClear"
                />
            </TransitionGroup>
        </div>
    </div>
</template>

<script>
import NotificationBanner from 'vcomponents/notifications/NotificationBanner.vue';
export default {
    components: {
        NotificationBanner,
    },
    data() {
        return {
            notifications: [],
            queueingNotifications: [],
        };
    },
    watch: {
        notifications(newNotificationsValue) {
            if (newNotificationsValue.length < 3 && this.queueingNotifications.length > 0) {
                this.display(this.queueingNotifications.pop());
            }
        },
    },
    created() {
        EventBus.on('notify:new', this.notify);
    },
    methods: {
        notify(payload) {
            this.add(payload);
        },
        add(payload) {
            this.notifications.length < 3 ? this.display(payload) : this.queue(payload);
        },
        display(payload) {
            this.notifications.push(payload);
            setTimeout(() => {
                this.onClear(payload.notifId);
            }, 4500);
        },
        onClear(id) {
            this.notifications = this.notifications.filter(
                (notification) => notification.notifId !== id,
            );
        },
        queue(payload) {
            this.queueingNotifications.push(payload);
        },
    },
};
</script>

<style scoped lang="scss">
@import '~@sellsy/styleguide/src/_variables';

.notification-handler {
    position: fixed;
    top: 32px;
    z-index: 3000;
    right: 24px;

    &.container {
        display: flex;
        flex-direction: column;
        align-items: center;
    }
}
.notification-transition-enter,
.notification-transition-leave-to {
    opacity: 0;
    transform: translateX(100%);
}
.notification-transition-move,
.notification-transition-enter-active,
.notification-transition-leave-active {
    transition: all 0.3s ease;
}
.notification-transition-leave-active {
    position: absolute;
}
</style>
